import { Registry } from '@react-registry'
import { LIST_TYPES } from '../list/utils'
import { BaseEditor, Editor, Node, Path, Range, Transforms } from 'slate'
import { cellType } from '../table'

export const withHtmlComment = (editor: BaseEditor) => {
  const { isVoid, isInline, normalizeNode, deleteBackward } = editor

  editor.isVoid = (element) => {
    return element?.['type'] === 'html-comment' ? true : isVoid(element)
  }

  editor.isInline = (element) => {
    if (element?.['type'] === 'html-comment' && element?.['attrs']?.['inline']) {
      return true
    }
    return isInline(element)
  }

  editor.deleteBackward = (unit) => {
    try {
      const selection = editor.selection
      if (selection && Range.isCollapsed(selection)) {
        const nodeEntry = Editor.above(editor, { at: selection?.anchor, match: (n) => n?.['type'] === 'html-comment' })
        if (nodeEntry) {
          Transforms.removeNodes(editor, { at: nodeEntry[1] })
        }
      }
      deleteBackward(unit)
    } catch (e) {
      console.error(
        'Error in deleteBackward while deleting HTML Comment',
        e,
        JSON.stringify({ selection: editor.selection, children: editor.children })
      )
    }
  }

  editor.normalizeNode = (entry) => {
    const [node, path] = entry
    if (node?.['type'] !== 'html-comment') return normalizeNode(entry)

    const listParent = Editor.above(editor, { at: path, match: (n) => LIST_TYPES.includes(n['type']) })
    const tableParent = Editor.above(editor, { at: path, match: (n) => n['type'] === 'table' })
    const tableCellParent = Editor.above(editor, { at: path, match: (n) => cellType.includes(n['type']) })
    const isInList = !!listParent

    const isInTableButNotInCell = !!tableParent && !tableCellParent
    if (isInList) {
      Editor.withoutNormalizing(editor, () => {
        Transforms.setNodes(editor, { attrs: { ...node?.['attrs'], inline: false } } as Partial<Node>, { at: path })
        Transforms.moveNodes(editor, { at: path, to: Path.next(listParent[1]) })
      })
      return
    }
    if (!!isInTableButNotInCell) {
      Transforms.moveNodes(editor, { at: path, to: Path.next(tableParent[1]) })
      return
    }

    return normalizeNode(entry)
  }

  return editor
}
Registry.register(withHtmlComment, { id: 'html-comment', registry: 'plugin' })
